module.exports = __webpack_public_path__ + "img/end-to-end-blue.cdf68887.png";